/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Tab from '../../components/Tab';
import { useFetch } from '../../hooks/useFetch';
import './Gobernator.scss';
import ListCandidates from './listCandidates';
import JSONGobMex from '../../utils/JSONGobMex';

const Gobernator = () => {
  const [searchParams] = useSearchParams();
  const paramsEstado = searchParams.get('estado');
  const theme = searchParams.get('theme') || ''
  console.log('THEME gob', theme)

  const estados = [
    {
      id: 0,
      state: 'Aguascalientes',
      url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-AGU_governors.json?timestamp=${new Date().getTime()}`,
    },
    {
      id: 1,
      state: 'Durango',
      url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-DUR_governors.json?timestamp=${new Date().getTime()}`,
    },
    {
      id: 2,
      state: 'Hidalgo',
      url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-HID_governors.json?timestamp=${new Date().getTime()}`,
    },
    {
      id: 3,
      state: 'Oaxaca',
      url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-OAX_governors.json?timestamp=${new Date().getTime()}`,
    },
    {
      id: 4,
      state: 'Quintana Roo',
      url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-ROO_governors.json?timestamp=${new Date().getTime()}`,
    },
    {
      id: 5,
      state: 'Tamaulipas',
      url: `https://data-ecp.infobae.com/infobae.com/2022/méxico/locales/MX-TAM_governors.json?timestamp=${new Date().getTime()}`,
    },
  ];
  const findEstado = estados.find((estado) => estado.state === paramsEstado);
  if (findEstado) {
    estados.sort((a, _b) => {
      if (a.id === findEstado.id) {
        return -1;
      }
      return 1;
    });
  }
  const [toggleState, setToggleState] = useState(0);
  const toggleTab = (index) => {
    setToggleState(index);
  };
  const currentUrl = estados[toggleState].url;
  const currentState = estados[toggleState].state || 'Aguascalientes';
  // const [data, loading, error, fetchData] = useFetch();
  const [data, loading, , fetchData] = useFetch();
  // console.log('loading', loading);
  // console.log('error', error);
  // console.log('data', data);
  useEffect(() => {
    fetchData(currentUrl);
  }, [toggleState]);

  // console.log(JSONGobMex[currentState]);
  const EstatusCandidates = () => {
    if (loading) {
      return (
        <>
          <div className="g-container__skeleton-container">
            {JSONGobMex[currentState].parties.map((e, i) => (<div key={i} className="g-container__skeleton-item" />))}
          </div>
          <div className="g-container__skeleton-footer" />
        </>
      );
    }
    return <ListCandidates currentState={currentState} currentData={data} />;
  };
  return (
    <div className="g-container">
      <Tab toggleTab={toggleTab} toggleState={toggleState} estados={estados} />
      {EstatusCandidates()}
    </div>
  );
};

export default Gobernator;
